import { create } from "zustand"

interface NavigationLeftState {
  id: string
  setId: (id: string) => void
}

export const useShowAffiliate = create<NavigationLeftState>((set) => ({
  id: "",
  setId: (id) => set({ id })
}))
